export const parseConfigurationString = (config) => {
    if (config) {
        try {
            return JSON.parse(config);
        }
        catch (error) {
            return {};
        }
    }
    return {};
};
export function getCurrentConfiguration() {
    var _a;
    const configurationDOMObject = window.document.querySelector(`meta[property="configuration"]`) ||
        window.document.querySelector(`meta[name="configuration"]`);
    return parseConfigurationString((_a = configurationDOMObject === null || configurationDOMObject === void 0 ? void 0 : configurationDOMObject.getAttribute("content")) !== null && _a !== void 0 ? _a : "");
}
export const getAEMUrl = (hash = "", url = "") => {
    const isAuthor = !!document.cookie.split(";").find((element) => element.indexOf("wcmmode") !== -1);
    const authorPath = isAuthor ? "?wcmmode=disabled" : "";
    return `${url}${authorPath}${hash}`;
};
//# sourceMappingURL=getCurrentConfiguration.js.map